import { Injectable, inject } from '@angular/core';
import { ConfigBaseFilter, ConfigService, ListLayout, ListLayoutMultipleComponent, ListSortOption, SimpleConfigBaseFilter } from 'gung-list';
import { map, Observable } from 'rxjs';
import { CustomerRequestsCardListComponent } from '../../components/customer-request/customer-requests-card-list/customer-requests-card-list.component';
import { CustomerRequest, CustomerRequestService } from '../customer-request/customer-request.service';
import { DateUtilService } from 'gung-common';

export class CustomerRequestStatusFilter extends SimpleConfigBaseFilter<CustomerRequest> {
  getName(): string {
    return 'STATUS';
  }

  getOptionIds(request: CustomerRequest): string[] {
    if (!request.processed && !request.rejected) {
      return ['PENDING'];
    } else if (request.processed && request.rejected) {
      return ['REJECTED'];
    } else if (request.processed && !request.rejected) {
      return ['ACCEPTED'];
    }
  }

  getOptionName(key: string): string {
    return key;
  }
}

export class CustomerRequestDateFilter extends SimpleConfigBaseFilter<CustomerRequest> {
  type = 'dateRangeFilter';

  constructor(protected dateUtilService: DateUtilService) {
    super();
  }

  getOptionIds(item: CustomerRequest): string[] {
    if (item.creationDate) {
      return [this.dateUtilService.getFormattedDateString(new Date(item.creationDate), 'yyMMdd')];
    }
    return [];
  }

  getOptionName(key: string): string {
    return key;
  }

  getName(): string {
    return 'DATE';
  }
}

@Injectable({
  providedIn: 'root'
})
export class CustomerRequestListConfigService implements ConfigService<CustomerRequest> {
  protected customerRequestService = inject(CustomerRequestService);
  protected dateUtilService = inject(DateUtilService);

  getFilters(): ConfigBaseFilter<CustomerRequest>[] {
    return [new CustomerRequestStatusFilter(), new CustomerRequestDateFilter(this.dateUtilService)];
  }

  getSortOptions(): ListSortOption<CustomerRequest>[] {
    return [];
  }

  getBatchSizes(): number[] {
    return [24];
  }

  getItemId(item: CustomerRequest): string {
    return item.id;
  }

  getSearchTerms(item: CustomerRequest): string[] {
    return [item.id, item.name, item.companyName, item.extra?.email];
  }

  getSearchGroupCss(): string {
    return 'd-none';
  }

  getLayouts(): ListLayout<CustomerRequest>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => CustomerRequestsCardListComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'CustomerRequestGrid'
      }
    ];
  }

  getItems(): Observable<CustomerRequest[]> {
    return this.customerRequestService.getCustomerRequestsInternal().pipe(
      map(requests =>
        requests.sort((a, b) => {
          if (a.creationDate > b.creationDate) return -1;
          if (a.creationDate < b.creationDate) return 1;
          return 0;
        })
      )
    );
  }
}
